module.exports = __webpack_public_path__ + "static/img/title-bg.2e1fcd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tst/title-bg.png
// module id = DdYP
// module chunks = 1